<template>
  <div>
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row>
        <b-col cols="7" class="d-none d-lg-block mt-10">
          <b-container>
            <img
              src="@/assets/images/background1.png"
              width="100%"
              v-if="getVersion === 'v1'"
            />
            <img
              src="@/assets/images/mainPaymentImage.png"
              width="100%"
              v-if="getVersion === 'v2'"
            />
          </b-container>
          <b-col cols="12">
            <b-container class="mt-10" v-if="getVersion === 'v1'">
              <h1 class="text-center font-size-xl pb-3">
                {{ $translate("confirmation") }}
              </h1>
              <p
                class="text-center font-size-large dodger-blue-text"
                :class="{ newVersionTextClass: getVersion === 'v2' }"
              >
                {{ $translate("withThisStepYouDontNeedTheValidationCode") }}
              </p>
            </b-container>
          </b-col>
        </b-col>
        <b-col lg="5" cols="12">
          <shetab-stepper v-if="getVersion === 'v1'"></shetab-stepper>
          <b-container
            :class="{ marginTenPercent: getVersion === 'v2' }"
            class="background-secondary border-radius-10px border-light-gray-1px mb-3"
          >
            <b-row no-gutters>
              <b-col cols="12" class="d-flex justify-content-center pt-1 pb-10">
                <img
                  src="@/assets/images/smsConfirm.png"
                  height="125"
                  width="125"
                />
              </b-col>
              <b-col
                v-if="!otpInputReadOnly"
                cols="12"
                class="d-flex justify-content-center font-size-small"
              >
                <span
                  class="dodger-blue-text"
                  :class="{ newVersionTextClass: getVersion === 'v2' }"
                  >{{ $translate("codeSentTo") }}:
                  <span class="font-weight-bold black-text">{{
                    getMobileNumber | persianDigit
                  }}</span>
                </span>
                <span
                  class="font-size-xs font-weight-bold gray-text cursor-pointer"
                  @click="changeNumber()"
                  :class="{ newVersionTextClass: getVersion === 'v2' }"
                  >({{ $translate("changeNumber") }})</span
                >
              </b-col>
              <b-col cols="12" v-if="!otpInputReadOnly">
                <b-form-input
                  class="form-control sms-confirm-input mx-1"
                  :placeholder="$translate('enterTheSentCode')"
                  v-mask="'#########'"
                  mask="false"
                  v-model="smsConfirmCode"
                  :class="{ secondVersionInputs: getVersion === 'v2' }"
                ></b-form-input>
              </b-col>
              <b-col
                v-if="getNationalCodeNeeded"
                cols="12"
                class="d-flex justify-content-center font-size-small"
              >
                <span
                  class="dodger-blue-text"
                  :class="{ newVersionTextClass: getVersion === 'v2' }"
                  >{{
                    $translate(
                      "ToUseThisSwitchYouNeedToEnterOwnerNationalCode"
                    )
                  }}:
                </span>
              </b-col>
              <b-col v-if="getNationalCodeNeeded" cols="12">
                <b-form-input
                  class="form-control sms-confirm-input mx-1"
                  :placeholder="$translate('enterTheOwnerNationalCode')"
                  v-mask="'##########'"
                  mask="false"
                  v-model="nationalCode"
                  :class="{ secondVersionInputs: getVersion === 'v2' }"
                ></b-form-input>
              </b-col>
              <b-col cols="12" class="text-center pb-3"
                ><span
                  class="font-size-small dodger-blue-text"
                  :class="{ newVersionTextClass: getVersion === 'v2' }"
                  >{{ $translate("ifYouDidntReceiveCode") }}</span
                >
              </b-col>
              <b-col cols="12" class="text-center pb-10">
                <Timer
                  ref="shetabValidationTimer"
                  :spanClass="'font-size-small font-weight-bold red-text'"
                  :duration="120000"
                  :timerKey="'shetabValidation'"
                  @expired="handleTimeExpired"
                />
              </b-col>
            </b-row>

            <b-row class="pb-9">
              <b-col cols="5" md="4" lg="5" xl="4">
                <button
                  type="button"
                  class="decline-button"
                  @click="eraseCode"
                  :class="{ newVersionButtonClass: getVersion === 'v2' }"
                >
                  {{ $translate("erase") }}
                </button>
              </b-col>
              <b-col cols="7" md="8" lg="7" xl="8">
                <button
                  type="button"
                  class="go-to-next-button"
                  @click="submitOTP()"
                  :class="{
                    'newVersionButtonClass backgroundColorDarkGreen':
                      getVersion === 'v2',
                  }"
                >
                  <b-row class="fill-width">
                    <b-col cols="9" md="10" lg="9" xl="10">{{
                      $translate("nextStep")
                    }}</b-col>
                    <b-col cols="3" md="2" lg="3" xl="2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        class="bi bi-arrow-left-short"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                        />
                      </svg>
                    </b-col>
                  </b-row>
                </button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
import shetabStepper from "@/components/ShetabStepper";
import Timer from "@/components/Timer";
import { shetabValidationMixin } from "@/mixins/ShetabMixins/ShetabValidationMixin";

export default {
  name: "shetabValidation",
  components: {
    Timer,
    shetabStepper: shetabStepper,
  },
  mixins: [shetabValidationMixin],
};
</script>

<style scoped>
.sms-confirm-input::placeholder {
  color: dodgerblue;
  font-size: 0.9rem;
}

.sms-confirm-input {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 75px;
}

.decline-button {
  width: 100%;
  height: 115%;
  border-radius: 10px;
  border: 1px solid black;
  background-color: transparent;
}

.go-to-next-button {
  width: 100%;
  height: 115%;
  border: none !important;
  border-radius: 10px;
  background-color: dodgerblue;
  color: white;
}

.newVersionTextClass {
  color: black !important;
}

.newVersionButtonClass {
  border-radius: 5px !important;
}

.backgroundColorDarkGreen {
  background-color: #1aaf29 !important;
}

.secondVersionInputs {
  border-radius: 10px !important;
  box-shadow: none !important;
  border: 1px solid lightgrey !important;
}

.marginTenPercent {
  margin-top: 15% !important;
}
</style>
